export class Audio {
  constructor(difference) {
    this.styleId = 1
    this.width = 56
    this.height = 56
    this.top = 10
    this.left = 10
    this.audioUrl = ""
    this.audioName = ""
    this.innerElement = "cxAudio"
    this.bgColor = "rgba(0, 0, 0, 0)"
    this.bgColorIsThemeColor = false
    this.background = []
    this.rotate = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.opacity = 100
    this.boxShadowColor = [0]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderIsThemeColor = false
    // 循环播放
    this.loopPlay = false
    // 自动播放
    this.autoplayStatus = false
    // 图标颜色
    this.iconPlaySrc = "https://p.ananas.chaoxing.com/star3/origin/5d43a5d29c3cf6e0f816cb53930414f9.png"
    this.iconPauseSrc = "https://p.ananas.chaoxing.com/star3/origin/aecd22204780784f3c7c99afdb2b45b2.png"
    this.iconPlayType = "img"
    this.iconPauseType = "img"
    this.iconPlayColor = "#444444"
    this.iconPauseColor = "#444444"
    // 静音只跟自动播放有关系
    this.muted = false
    // 边距
    this.legendPadding = 8
    this.paddingTop = 8
    this.paddingRight = 8
    this.paddingLeft = 8
    this.paddingBottom = 8
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
